$(window).on("load", function (e) {
    $(".section_hero").css('visibility', 'visible');
});

$(document).ready(function () {

	// MENU MOBILE
	$('.menu-nav').click(function(e){
	    e.preventDefault();
	    $(this).toggleClass('opened');
	    $('nav').toggleClass('opened');
	    $('body').toggleClass('overflow');
	});
	$('.menu-item a').click(function(){
		$('body').removeClass('overflow');
		$('nav, .menu-nav').removeClass('opened');
	});

	// SLICK SLIDER - DEPOIMENTOS
    $('.slider_hero').slick({
    	slidesToShow: 1,
    	slidesToScroll: 1,
		arrows: false,
		dots: true
	});

	// SLICK SLIDER - MÍDIAS
    $('.slider_media').slick({
    	slidesToShow: 5,
    	slidesToScroll: 1,
		dots: false,
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
					arrows: false,
					dots: true
				},
			},
			{
				breakpoint: 960,
				settings: {
					slidesToShow: 4,
					arrows: false,
					dots: true
				}
			}
		]
	});

    // SMOOTH SCROLL
	jQuery(document).ready(function () {
		jQuery('.scroll a').click(function () {
			var target = jQuery(this).attr('href').split('#').pop();
			jQuery('html, body, index').animate({ scrollTop: jQuery('#' + target).offset().top }, 1000);
			return false;
		});
	});

	// FIX HEIGHT 100VH
	document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`)

	// TABS
	$('ul.tabs li').click(function () {
	var tab_id = $(this).attr('data-tab');
	$('ul.tabs li').removeClass('current');
	$('.tab-content').removeClass('current');
	$(this).addClass('current');
	$("#" + tab_id).addClass('current');
	});

	// STICKY HEADER
    $(function () {
        var body = $("body");
        $(window).scroll(function () {
        var scroll = $(window).scrollTop();
            if (scroll > 0) {
                body.addClass("sticky");
            } else {
                body.removeClass("sticky");
            }
        });
    });

}); 